<template>
  <div class="sidebar">
    <el-menu
      v-if="items.length"
      class="sidebar-el-menu"
      @select="handleSelect"
      
      :collapse="collapse"
      background-color="#fff"
      text-color="#111"
      active-text-color="#3388FF"
      unique-opened
      router
    >
      <template v-for="item in items">
        
        <el-menu-item
          class="el-menu-item"
          :class="isSelected == item.url?'active':''"
          :index="item.url"
          :key="item.id"
          :route="{path: item.url}"
        >
          <template slot="title">
            <!-- <i :class="item.icon" class="icon"></i> -->
            <img :src="item.iconUrl" alt="" class="icon">
            <span class="text">{{ item.name }}</span>
          </template>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script>
import bus from "../common/bus";
import config from "../../assets/javascript/config";
export default {
  data() {
    return {
      collapse: false,
      items: [],
      currPath: localStorage.getItem("setCurentUrl"),
      token: this.$store.getters.AppInfo.accessToken,
      isSelected: "",
      menuPage: ''
    };
  },
  computed: {
    onRoutes() {
      return this.$route.path.split("/")[1];
    }
  },
  mounted() {
    window.addEventListener("load", () => {
      //写入你想要执行的代码
      if (this.menuPage == 'cashier') {
        this.items = JSON.parse(localStorage.getItem("cashierMenu"));
        this.isSelected = this.$route.path;
      } else if (this.menuPage == 'shop') {
        this.isSelected = this.$route.path;
      } else if (this.menuPage == 'data') {
        this.isSelected = this.$route.path;
      }
    });
    this.menuPage = this.$store.getters.menuPage;
    this.init();
  },
  watch: {
    "$store.getters.menuPage": function(old) {
      this.menuPage = this.$store.getters.menuPage;
      this.init();
    },
    "$store.getters.curentUrl": function(old) {
      if (old != 'url') {
        this.init();
      }
    },
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key);
      this.isSelected = key;
    },
    init() {
      this.items = [];
      if (this.menuPage == 'cashier') {
        this.items = JSON.parse(localStorage.getItem("cashierMenu"));
        let url = localStorage.getItem("setCurentUrl") == 'url' ? '':localStorage.getItem("setCurentUrl");
        this.isSelected = url || this.items[0].url;
        this.$store.commit("setCurentUrls", url);
      } else if (this.menuPage == 'shop') {
        this.items = JSON.parse(localStorage.getItem("shopMenu"));
        this.isSelected = this.items[0].url;
      } else if (this.menuPage == 'data') {
        this.items = JSON.parse(localStorage.getItem("dataMenu"));
        let url = localStorage.getItem("setCurentUrl") == 'url' ? '' : localStorage.getItem("setCurentUrl");
        console.log(url);
        this.isSelected = '/' + url || this.items[0].url;
        this.$store.commit("setCurentUrls", url);
      }
    },
    beforeunloadHandler(e) {    //根据事件进行操作进行操作
      console.log(e)
      console.log('浏览器刷新') 
    },
  }
};
</script>

<style scoped lang="less">
.sidebar {
  background: #fff;
  display: block;
  position: absolute;
  left: 0;
  top: 58px;
  bottom: 0;
  z-index: 9;
  overflow: auto;
}

.sidebar::-webkit-scrollbar {
  width: 0;
}

.sidebar-el-menu:not(.el-menu--collapse) {
  /* width: 186px; */
  width: 160px;
}

.sidebar > ul {
  height: 100%;
}

.show-ellipsis {
  display: block;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.show-ellipsis ::after {
  content: "...";
}
.el-menu-item {
  height: 54px;
  // line-height: 40px;
  display: flex;
  align-items: center;
  // justify-content: center;
  font-size: 20px;
  color: #111;
  margin-bottom: 10px;
  &:hover {
    color: #fff !important;
    background: #3388FF !important;
  }

  .icon {
    width: 24px;
    height: 24px;
    margin-right: 5px;
  }
}
.sidebar .active{
  color: #fff !important;
  background: #3388FF !important;
}
/deep/ .is-active {
  color: rgb(17, 17, 17) !important;
  background-color: rgb(255, 255, 255);
}
</style>

<style lang="less">
.sidebar .el-menu-item.is-active {
  background-color: #fff;
}
</style>
